import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';

import { LanguageProvider } from '@/components/i18n/language-provider';
import { listenForAdAccountConversions } from '@/components/connectors/ad-account-connection';
import { Toaster } from '@/components/ui/sonner';
import { startAnalytics } from '@/lib/ga4';
import { queryClient } from '@/lib/query-client';
import { router } from '@/lib/router';
import { initSentry } from '@/lib/sentry';

initSentry();
startAnalytics();
listenForAdAccountConversions();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root element not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <RouterProvider router={router} />
        <Toaster closeButton />
      </LanguageProvider>
    </QueryClientProvider>
  </StrictMode>,
);
